import { Outlet, useRoutes } from "react-router-dom";
import Loadable from "components/Loadable";
import { lazy } from "react";
import { ROUTES } from "utils/constants";
import InfoLayout from "components/Layout/InfoLayout";
import AppLayout from "components/Layout/AppLayout";

// Landing & Info pages
const LandingPage = Loadable(lazy(() => import("pages/landing")));
const Policy = Loadable(lazy(() => import("pages/policy")));
const Terms = Loadable(lazy(() => import("pages/terms")));
const About = Loadable(lazy(() => import("pages/about")));
const SubscriptionPlans = Loadable(lazy(() => import("pages/subscriptionPlans")));
const Report = Loadable(lazy(() => import("pages/report")));
const FeedbackForm = Loadable(lazy(() => import("pages/feedBack")));
const Mission = Loadable(lazy(() => import("pages/mission")));
const Support = Loadable(lazy(() => import("pages/support")));
const FAQ = Loadable(lazy(() => import("pages/faqs")));
const Profile = Loadable(lazy(() => import("pages/profileDetail")));

// Auth pages
const Login = Loadable(lazy(() => import("pages/login")));
const Register = Loadable(lazy(() => import("pages/register")));
const Forget = Loadable(lazy(() => import("pages/forgetPassword")));
const Checkout = Loadable(lazy(() => import("pages/checkout")));

// App pages
const AppRedirect = Loadable(lazy(() => import("pages/appRedirect")));
const PromptsPage = Loadable(lazy(() => import("pages/prompts")));
const LeadersPage = Loadable(lazy(() => import("pages/leaders")));
const AssessmentPage = Loadable(lazy(() => import("pages/assessment")));
const PromptListPage = Loadable(lazy(() => import("pages/promptList")));
const PersonalityDashboard = Loadable(lazy(() => import("pages/personalityDashboard")));
const OnboardingPage = Loadable(lazy(() => import("pages/onboarding")));

export default function Routes() {
    return useRoutes([
        // Info layout routes (landing, terms, about, etc.)
        {
            element: <InfoLayout />,
            children: [
                { path: ROUTES.ROOT, element: <LandingPage /> },
                { path: ROUTES.ABOUT, element: <About /> },
                { path: ROUTES.MISSION, element: <Mission /> },
                { path: ROUTES.SUPPORT, element: <Support /> },
                { path: ROUTES.FEEDBACK, element: <FeedbackForm /> },
                { path: ROUTES.REPORT, element: <Report /> },
                { path: ROUTES.SUBSCRIPTION_PLANS, element: <SubscriptionPlans /> },
                { path: ROUTES.FAQ, element: <FAQ /> },
            ],
        },
        // Auth routes
        {
            element: <Outlet />,
            children: [
                { path: ROUTES.APP_ONBOARDING, element: <OnboardingPage /> },
                { path: ROUTES.APP_ASSESSMENT, element: <AssessmentPage /> },
                { path: ROUTES.LOGIN, element: <Login /> },
                { path: ROUTES.REGISTER, element: <Register /> },
                { path: ROUTES.CHECKOUT, element: <Checkout /> },
                { path: ROUTES.FORGOT_PASSWORD, element: <Forget /> },
                { path: ROUTES.PRIVACY_POLICY, element: <Policy /> },
                { path: ROUTES.TERMS_AND_CONDTION, element: <Terms /> },
            ],
        },
        {
            element: <AppLayout />,
            children: [
                // /app - redirect based on assessment status
                { path: ROUTES.APP, element: <AppRedirect /> },
                // /app/prompts - prompts list (optional :id for specific prompt)
                { path: ROUTES.APP_PROMPTS, element: <PromptsPage /> },
                { path: ROUTES.APP_PROMPT_DETAIL, element: <PromptsPage /> },
                { path: ROUTES.APP_LEADERS, element: <LeadersPage /> },
                { path: ROUTES.APP_PERSONALITY_DASHBOARD, element: <PersonalityDashboard /> },
                // /app/favourites, /app/seen, /app/unseen - prompt list pages
                { path: ROUTES.APP_FAVOURITES, element: <PromptListPage /> },
                { path: ROUTES.APP_SEEN, element: <PromptListPage /> },
                { path: ROUTES.APP_UNSEEN, element: <PromptListPage /> },
                { path: ROUTES.PROFILE, element: <Profile /> }
            ],
        },
    ]);
}
